import { render, staticRenderFns } from "./FormItemSpecification.vue?vue&type=template&id=abe3fe10&scoped=true"
import script from "./FormItemSpecification.vue?vue&type=script&lang=js"
export * from "./FormItemSpecification.vue?vue&type=script&lang=js"
import style0 from "./FormItemSpecification.vue?vue&type=style&index=0&id=abe3fe10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe3fe10",
  null
  
)

export default component.exports